export default {
  ENVOY_GRPC_POINT: "https://богдашка.рф/"
  //ENVOY_GRPC_POINT: "http://127.0.0.1:80/"
  //ENVOY_GRPC_POINT: "http://95.163.236.197:10000"
}
